import { Component, Input } from '@angular/core';
import { Collection } from '../../interfaces/custom/collection';
import { RootService } from '../../services/root.service';

@Component({
    selector: 'app-collection-card',
    templateUrl: './collection-card.component.html',
    styleUrls: ['./collection-card.component.scss']
})
export class CollectionCardComponent {
    @Input() collection: Collection;
    @Input() layout: 'grid-nl'|'grid-lg'|'list-nl'|'list-sm'|null = null;

    constructor(public root: RootService) { }
}
